import React from 'react'

const Addresses = () => (
  <section className="addresses">
    <address>
      1030 N. Clark St.
      <br />
      Suite 303
      <br />
      Chicago, Illinois 60610
      <br />
      <a href="tel:+13127250225">312-725-0225</a>
    </address>
  </section>
)

export { Addresses }
